import { useParams, Link, Navigate } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import StickyEmergencyBar from "@/components/support/StickyEmergencyBar";
import { TroubleshootWizard } from "@/components/support/TroubleshootWizard";
import { WIZARDS } from "@/lib/supportContent";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const SupportTroubleshoot = () => {
  const { slug } = useParams();
  const wizard = WIZARDS.find((w) => w.slug === slug);

  if (!wizard) return <Navigate to="/support" replace />;

  return (
    <>
      <SEO
        title={`${wizard.robot} — ${wizard.issue} | Neil AI Support`}
        description={`Step-by-step troubleshooting for ${wizard.robot}: ${wizard.issue}.`}
      />
      <div className="min-h-screen bg-[#05070A] text-white pb-32">
        <Navigation />
        <main className="max-w-3xl mx-auto px-4 pt-32 md:pt-40">
          <Button asChild variant="ghost" className="mb-6 text-muted-foreground hover:text-white">
            <Link to="/support"><ChevronLeft className="w-4 h-4 mr-1" />Back to Support</Link>
          </Button>
          <div className="mb-8">
            <div className="text-xs uppercase tracking-wider text-primary mb-2">{wizard.robot}</div>
            <h1 className="text-3xl md:text-4xl font-bold">{wizard.issue}</h1>
          </div>
          <TroubleshootWizard wizard={wizard} />
        </main>
        <Footer />
        <StickyEmergencyBar />
      </div>
    </>
  );
};

export default SupportTroubleshoot;
